import { seoContent } from '@/mocks/content';

interface CatDisplay {
  name: string;
  url: string;
  imageUrl: string;
}

const catDisplays: CatDisplay[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Closeup%20of%20premium%20designer%20sneakers%20on%20cream%20concrete%20surface%2C%20soft%20side%20window%20light%2C%20macro%20texture%20detail%20visible%2C%20editorial%20footwear%20photography%2C%20warm%20minimal%20aesthetic%2C%20sophisticated%20composition%2C%20subtle%20shadows%2C%20neutral%20beige%20palette&width=600&height=480&seq=cat-v2-shoes&orientation=landscape'
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20cashmere%20hoodie%20draped%20over%20minimal%20wooden%20chair%20in%20sunlit%20corner%2C%20lifestyle%20fashion%20photography%2C%20warm%20natural%20light%2C%20cream%20walls%2C%20soft%20textured%20fabric%2C%20scandinavian%20interior%20aesthetic%2C%20calm%20atmosphere&width=600&height=480&seq=cat-v2-hoodies&orientation=landscape'
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20white%20cotton%20t-shirt%20hanging%20elegantly%20on%20minimal%20wooden%20hanger%20against%20beige%20textured%20wall%2C%20soft%20natural%20daylight%2C%20editorial%20fashion%20photography%2C%20clean%20aesthetic%2C%20fabric%20texture%20visible%2C%20sophisticated%20minimal%20style&width=600&height=480&seq=cat-v2-tshirts&orientation=landscape'
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20displayed%20on%20minimal%20clothing%20rack%2C%20soft%20gallery%20spotlight%2C%20editorial%20outerwear%20photography%2C%20warm%20neutral%20background%2C%20textured%20fabric%20details%2C%20modern%20contemporary%20aesthetic%2C%20clean%20sophisticated%20look&width=600&height=480&seq=cat-v2-jackets&orientation=landscape'
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Well-tailored%20linen%20trousers%20and%20shorts%20artistically%20folded%20on%20cream%20linen%20fabric%2C%20soft%20morning%20sunlight%2C%20minimal%20fashion%20flatlay%20photography%2C%20warm%20neutral%20tones%2C%20textured%20fabric%20visible%2C%20clean%20elegant%20composition&width=600&height=480&seq=cat-v2-pants&orientation=landscape'
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20caps%20and%20beanies%20arranged%20on%20minimal%20wooden%20shelf%2C%20soft%20afternoon%20sunlight%2C%20editorial%20accessories%20photography%2C%20warm%20cream%20walls%2C%20varied%20textures%2C%20clean%20modern%20display%2C%20contemporary%20lifestyle%20aesthetic&width=600&height=480&seq=cat-v2-headwear&orientation=landscape'
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20two-piece%20outfit%20elegantly%20displayed%20on%20minimal%20mannequin%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20backdrop%2C%20harmonious%20color%20palette%2C%20clean%20sophisticated%20composition%2C%20modern%20aesthetic&width=600&height=480&seq=cat-v2-sets&orientation=landscape'
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20basics%20neatly%20arranged%20on%20soft%20cream%20towel%2C%20gentle%20morning%20light%2C%20minimal%20intimate%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20soft%20fabric%20texture%2C%20clean%20simple%20composition%2C%20elegant%20presentation&width=600&height=480&seq=cat-v2-underwear&orientation=landscape'
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20displayed%20flat%20on%20cream%20background%2C%20soft%20studio%20lighting%20highlighting%20fabric%20details%2C%20editorial%20sportswear%20photography%2C%20warm%20neutral%20tones%2C%20textured%20material%20visible%2C%20clean%20athletic%20aesthetic%2C%20minimal%20composition&width=600&height=480&seq=cat-v2-jersey&orientation=landscape'
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20fashion%20accessories%20collection%20scattered%20on%20cream%20marble%20tray%2C%20soft%20window%20light%2C%20editorial%20jewelry%20photography%2C%20warm%20neutral%20aesthetic%2C%20mixed%20metals%20and%20textures%2C%20clean%20luxurious%20composition%2C%20sophisticated%20minimal%20style&width=600&height=480&seq=cat-v2-accessories&orientation=landscape'
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20handbag%20standing%20on%20minimal%20cream%20pedestal%2C%20soft%20gallery%20lighting%2C%20editorial%20luxury%20product%20photography%2C%20warm%20neutral%20backdrop%2C%20leather%20grain%20texture%20visible%2C%20clean%20sophisticated%20composition%2C%20modern%20elegance&width=600&height=480&seq=cat-v2-bags&orientation=landscape'
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20artistically%20coiled%20on%20cream%20suede%20surface%2C%20soft%20directional%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20brass%20buckle%20detail%2C%20clean%20minimal%20composition%2C%20luxurious%20texture&width=600&height=480&seq=cat-v2-belts&orientation=landscape'
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20glass%20perfume%20bottle%20on%20cream%20silk%20fabric%2C%20soft%20diffused%20studio%20lighting%20with%20gentle%20reflections%2C%20editorial%20fragrance%20photography%2C%20warm%20golden%20accents%2C%20clean%20elegant%20composition%2C%20sophisticated%20minimal%20aesthetic&width=600&height=480&seq=cat-v2-perfumes&orientation=landscape'
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20lifestyle%20items%20artistically%20arranged%20on%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20flatlay%20photography%2C%20warm%20neutral%20aesthetic%2C%20mixed%20materials%20and%20textures%2C%20harmonious%20composition%2C%20clean%20organized%20look%2C%20modern%20catalog%20style&width=600&height=480&seq=cat-v2-other&orientation=landscape'
  }
];

export default function CategoryGrid() {
  return (
    <section id="categorias" className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 mb-14 md:mb-16">
          <div className="lg:w-1/3">
            <span className="text-xs md:text-sm font-semibold text-foreground-400 uppercase tracking-widest">
              {seoContent.categoryTitle}
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl italic text-foreground-900 mt-2">
              {seoContent.categorySubtitle}
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
              {seoContent.categoryDesc}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {catDisplays.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} - CSSBuySpreadsheet`}
                  title={`${cat.name} na planilha CSSBuy`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
                  CSSBuy
                </span>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors">
                  {cat.name}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}